module.exports = __webpack_public_path__ + "common/search/icon-women-70994ee63ac1a13e99d1ad5fc9f41262.svg";